import Avatar from "@components/profile/avatar";
import { IAgoraRTCRemoteUser } from "agora-rtc-sdk-ng";
import UserVideo from "../UserVideo/userVideo";

interface IUserVideoDisplayProps {
    username: string,
    size: number,
    user?: IAgoraRTCRemoteUser
}

const UserVideoDisplay = (props: IUserVideoDisplayProps) => {
    const { username, size, user } = props;
    return (
        <div className="VideoCall__Info">
            <div className="VideoCall__Info">
                {
                    !user ?
                    <div className="VideoCall__Avatar"
                        style={{minHeight: '150px', minWidth: '150px'}}
                    >
                        <Avatar
                            username={username}
                            roleCode="PR"
                            size={size}
                            editable={false}
                        />
                        <div className="VideoCall__MiniInfoName">
                            <em className="fas fa-user" />
                            <p className="VideoCall__MiniInfoNameText"> {username} </p>
                        </div>
                    </div>
                    :
                    <UserVideo user={user} />
                }
            </div>
        </div>
    )
}

export default UserVideoDisplay;
